import { GetTimeseriesRequest } from "../types/timeseries";
import { useQuery } from "react-query";
import { getAggregationLevelService } from "../services/aggregationLevel";
import { useAuthContext } from "./useAuthContext";
import useQueryState from "./useQueryState";

export type UseTimeseries = GetTimeseriesRequest;

const useAggregationLevel = () => {
  const { parsedToken } = useAuthContext();
  const { email: userEmail } = parsedToken || {};
  const {
    queryState: { country },
  } = useQueryState();

  const getAggregationLevel = useQuery(
    ["aggregationLevel", country, userEmail],
    async () => {
      return await getAggregationLevelService({ country });
    },
    {
      refetchOnWindowFocus: false,
      refetchOnMount: false,
      retry: false,
      enabled: !!country,
    },
  );

  return {
    getAggregationLevel,
  };
};

export default useAggregationLevel;
